import { mockFormField } from '@domgen/dgx-fe-forms/layout';
import { CmsSignInForm } from '../../models/cms/cms-sign-in-form.interface';

export const mockCmsSignInForm: CmsSignInForm = {
  signInDetailsForm: {
    emailAddressField: mockFormField,
    passwordField: mockFormField,
  },
};
